import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import icoback from '../img/ico-back.svg';
import icosearch from '../img/ico-search.svg';
import icoclose from '../img/ico-close.svg';
import strings from '../strings.js'
import YtCard from '../YtCard';
import SelectingYesNoYtCard from '../SelectingYesNoYtCard';
import useYtSearch from '../useYtSearch';
import { toast } from 'react-toastify';

import homeLogoBg from '../img2026/homeLogoBg.jpg';

const API_URL = "https://starboxkod.com/api";

const song1 = {
    "song_num": 110108,
    "song_name": "给我多一点",
    "singer": "SHE",
    "language": "国语",
    "server_id": "C",
    "rel_path": "05\\110108"
}

// Regex to extract video ID from various YouTube URL formats
function extractYouTubeVideoId(url) {
    const regExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regExp);
    return match ? match[1] : null;
}

export function Yt({stateVer, lang, selectingYesNo, tableNo, footerDisabled, stateYouTube}) {

    const navigate = useNavigate()

    if (stateYouTube == false) {
        navigate("/home");
    }

    const [searchTerm, setSearchTerm] = useState("");
    const [ytSearchTerm, setYtSearchTerm] = useState("");

    const {
        loading,
        error,
        songs,
    } = useYtSearch(ytSearchTerm)
    
    function handleSearch(e) {
        setSearchTerm(e.target.value)
    }
    
    const [selectingYesNoSong, setSelectingYesNoSong] = useState({});
    
    function nowSelectSong ({ song }) {
        //check if it's empty, if so then intialise
        navigate("select");
        setSelectingYesNoSong(song);
    }
    
    // Function to handle direct link verification
    async function handleDirectVideoLink(videoId) {
        try {
            // 1 & 2. Check if the video is a real link and is public/unlisted using YouTube's oEmbed endpoint
            const oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;
            const oEmbedRes = await fetch(oEmbedUrl);
            
            if (!oEmbedRes.ok) {
                if (oEmbedRes.status === 401) {
                    toast.error(lang ? "此视频为私密视频，无法播放。" : "This video is private and cannot be played.");
                } else {
                    toast.error(lang ? "找不到视频。请检查链接是否正确。" : "Video not found. Please check the link and try again.");
                }
                return;
            }
            
            const videoData = await oEmbedRes.json();
            
            // 3. Check if the video is under 10 minutes
            const durationRes = await fetch(`${API_URL}/ytduration/${videoId}`);
            if (!durationRes.ok) {
                toast.error(lang ? "无法验证视频长度。" : "Failed to verify video length.");
                return;
            }

            const { isUnder10Mins } = await durationRes.json();

            if (!isUnder10Mins) {
                toast.error(lang 
                    ? "为了保证系统流畅处理并提供最佳体验，目前仅支持10分钟以内的视频。感谢您的理解！🙏" 
                    : "To ensure smooth system processing and a great experience for everyone, we currently support videos under 10 minutes. Thanks for understanding! 🙏",
                    { style: { width: '400px' } } 
                );
                return;
            }

            // 4. All checks passed! Construct dummy object & trigger selection card
            const dummySong = {
                id: { videoId: videoId },
                snippet: {
                    title: videoData.title || "YouTube Video",
                    channelTitle: videoData.author_name || "YouTube Channel",
                }
            };
            
            nowSelectSong({ song: dummySong });

        } catch (err) {
             console.error("Link processing error: ", err);
             toast.error(lang ? "处理链接时出错，请重试。" : "Error processing link, please try again.");
        }
    }


    return (<>
    <div className="heatder">
        <a onClick={(e) => {e.preventDefault(); navigate(-1)}}>
        <img
            src={icoback}
            alt="home"
        />
        </a>
        <div className = "headersearch">
            <img className = "headersearchIcon"
                src={icosearch}
                alt="search"
            />
            <input
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        // Check if search term contains a YouTube domain
                        const isLink = searchTerm.includes('youtube.com') || searchTerm.includes('youtu.be');
                        if (isLink) {
                            const videoId = extractYouTubeVideoId(searchTerm);
                            if (videoId) {
                                handleDirectVideoLink(videoId);
                            } else {
                                toast.error(lang ? "无效的 YouTube 链接格式" : "Invalid YouTube link format");
                            }
                        } else {
                            // Normal search
                            setYtSearchTerm(searchTerm)
                        }
                    }}}
                placeholder={lang ? strings.cn.search : strings.en.search}
                value={searchTerm}
                onChange={handleSearch}
            />
            <a onClick={(e) => {e.preventDefault(); setSearchTerm("");}}>
            <img className = "headersearchClose"
                src={icoclose}
                alt="search"                
            />
            </a>
        </div>
    </div>
    <div className ="headerBelow purple" style={{marginTop: '62px', backgroundSize:'100% 100%'}}>{lang ? strings.cn.yt : strings.en.yt}</div>
    <div className="language-bar-container">
        <div className="language-bar">
        </div>
    </div>

    <div className="song-container" id="song-container" style={{ marginBottom: footerDisabled ? "-55px" : ""}}>
    {songs?.length > 0
        ? (
            <>
                {songs.map((song, index) => {
                    return <YtCard song={song} key={song.song_num} lang={lang} onClick={() => { nowSelectSong({song});}}/>
                })}     
            </>
        ) :
        (
            <div className="empty">
                <h2>No songs found</h2>
            </div>
        )}
    </div>

    {loading && 'Loading...'}
    {error && 'Error...'}

    { selectingYesNo && (
        <>
        <SelectingYesNoYtCard song={selectingYesNoSong} lang={lang} onClick={() => { navigate(-1);}} stateVer={stateVer} tableNo={tableNo}/>
        </>
    )}
    
</>)}